import { z } from 'zod';
import { attachmentSchema } from '../../attachments/index.js';
import { SecurityLevel } from '../../shared/index.js';
export var MeetingEventDocumentType;
(function (MeetingEventDocumentType) {
    MeetingEventDocumentType["OTHER"] = "other";
    MeetingEventDocumentType["AGENDA_OUTLINE"] = "agenda_outline";
    MeetingEventDocumentType["AGENDA_PACKAGE"] = "agenda_package";
    MeetingEventDocumentType["MINUTES"] = "minutes";
    MeetingEventDocumentType["MEETING_BODY_MINUTES"] = "meeting_body_minutes";
    MeetingEventDocumentType["TRANSCRIPT"] = "transcript";
    MeetingEventDocumentType["PUBLIC_NOTICE"] = "public_notice";
    MeetingEventDocumentType["PUBLIC_COMMENTS"] = "public_comments";
})(MeetingEventDocumentType || (MeetingEventDocumentType = {}));
export const meetingEventDocumentCreateSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    securityLevel: z.enum(SecurityLevel),
    allowedUserIds: z.preprocess((val) => (Array.isArray(val) ? val : []), z.array(z.number().int().positive())),
    attachment: attachmentSchema,
    type: z.enum(MeetingEventDocumentType),
    customType: z.string().max(255).nullish(),
});
export const meetingEventDocumentUpdateSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    securityLevel: z.enum(SecurityLevel),
    allowedUserIds: z.preprocess((val) => (Array.isArray(val) ? val : []), z.array(z.number().int().positive())),
    customType: z.string().max(255).nullish(),
});
export const meetingEventDocumentReorderSchema = z.object({
    meetingEventDocuments: z.array(z.object({
        id: z.number(),
    })),
});
export const transcriptUpdateSchema = z.object({
    text: z.string().min(1, 'Transcript text is required'),
});
export { formatPreciseTimestamp } from '@govinity/shared-config/transcript-parser';
